import jQuery from 'jquery';

const callbacks = {
  // Legacy v1 callback, for v2 this is moved into javascripts/comments.ts
  showCommentForm: event => {
    const $emptyComment = jQuery(event.target).closest('.comment-empty');
    const $tabbedScroller = $emptyComment.closest(
      '.tabbed-record__scroll-container'
    );
    let initialHeight, finalHeight;
    if ($tabbedScroller.length) initialHeight = $emptyComment.outerHeight();

    $emptyComment.removeClass('comment-empty');

    // If empty comment is in a tabbed scroller, then adjust the scroll position so that the newly expanded
    // comment does not cover the comment that is visually at the bottom of the scroll container (may be the
    // bottom-most comment, or some other comment if user has scrolled up to a different comment before expanding
    // the $emptyComment).
    if ($tabbedScroller.length) {
      requestAnimationFrame(() => {
        finalHeight = $emptyComment.outerHeight();
        const initialScroll = $tabbedScroller.scrollTop();
        $tabbedScroller.scrollTop(initialScroll + finalHeight - initialHeight);
      });
    }
  },

  // Legacy v1 callback, for v2 this is moved into javascripts/ideas/idea_comment.ts
  showIdeaCommentForm: event => {
    jQuery(event.target)
      .parents('.idea-comment-empty')
      .removeClass('idea-comment-empty')
      .addClass('idea-comment-focused');
  },

  hideStaticContent: component => {
    if (component.enclosingElement) {
      // If the aha-editor is rendered inside a dashboard panel we need
      // to let the panel know when it was mounted to apply some style changes.
      const dashboardPanel = component.enclosingElement.closest(
        'div[id^="Dashboard-Panel-"]'
      );
      if (dashboardPanel) dashboardPanel.dataset.ahaEditor = 'ready';

      jQuery(component.enclosingElement)
        .find('.aha-editor-field-static-content')
        .hide();
    }
  },
  // For the creation modals that have templates they need to apply, attach the
  // editor to a location where they can get access to it. When the form layout
  // is changed is when this is needed, so adding it outside the section that
  // changes is required.
  attachToCreateModal: editor => {
    jQuery(
      '[data-js-id="feature_form"], [data-js-id="epic_form"], [data-js-id="idea_form"]'
    ).data('descriptionAhaEditor', editor);
  },
};

export const runCallback = (callbackName, ...args) => {
  const callbackToRun = callbacks[callbackName];
  if (!callbackToRun) {
    throw new Error(`Callback ${callbackName} does not exist`);
  }

  callbackToRun(...args);
};

export default callbacks;
